import { Variant } from "@mui/material/styles/createTypography";
import Typography from "@mui/material/Typography";

const sizeToVariant = {
  small: "bodySmall",
  medium: "bodyMedium",
  large: "bodyLarge",
};

export const APButtonLink = ({
  text,
  onClick,
  noUnderline = false,
  size = "small",
}: {
  text: string;
  onClick: () => void;
  noUnderline?: boolean;
  size?: "small" | "medium" | "large";
}) => {
  return (
    <Typography
      variant={sizeToVariant[size] as Variant}
      color="primary"
      sx={{
        textDecoration: noUnderline ? "none" : "underline",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      {text}
    </Typography>
  );
};
